<template>
  <div v-if="hasCardData" class="sitter-card-box lg:w-1/2">
    <div class="mx-16 mt-16 mb-24 md:mb-56">
      <p class="flex text-body mb-12">
        What your profile looks like to families
        <curving-arrow-icon class="relative bottom-[-10px] ml-4" />
      </p>
      <SitterCard
        :name="sitterCardName"
        :years-experience="profilePreview.yearsExperience"
        :city="city"
        :state-abbr="stateAbbr"
        :description="profilePreview.bio"
        :idv="idv"
        :badges="badges"
        :min-rate="profilePreview.minRate"
        :max-rate="profilePreview.maxRate"
        :photo-upload-avatar="!hasPhoto"
        :photo-profile-type="photoProfileType"
        :photo-url="account?.croppedPhoto"
        custom-classes="max-w-[375px]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import SitterCard from '@/components/sitter_card/SitterCard.vue';
import CurvingArrowIcon from '@/graphics/icons/CurvingArrowIcon.vue';
import type { Account } from '@/models/account';
import { CareType } from '@/types/care_type';
import { type ProfileCompletePreviewData, qualificationsToBadges } from '@/lib/sitterOnboarding/profileCompletePreview';

defineOptions({ name: 'ProfileCompletePreview' });

const props = withDefaults(
  defineProps<{
    account?: Account | null;
    profilePreview?: ProfileCompletePreviewData | null;
    photoProfileType?: CareType;
  }>(),
  { account: null, profilePreview: null, photoProfileType: CareType.BABYSITTER }
);

const hasCardData = computed(() => !!(props.account && props.profilePreview?.bio));
const sitterCardName = computed(() => `${props.account?.firstName ?? ''} ${props.account?.lastName?.[0] ?? ''}`);
const city = computed(() => props.account?.location?.cityname || '');
const stateAbbr = computed(() => props.account?.location?.stateabbr || '');
const hasPhoto = computed(() => !!props.account?.croppedPhoto);
const idv = { verdict: 'passed' };
const badges = computed(() => qualificationsToBadges(props.profilePreview?.qualifications ?? []));
</script>

<style lang="scss" scoped>
.sitter-card-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffeef8;
  background-image: url('@/images/account/pink_swoop.svg');
  background-size: 100% 90%;
  background-repeat: no-repeat;
  background-position: bottom;
  min-height: 349px;
  border-radius: 4px;
}
</style>
